import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsFacade, addFullStop } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-my-project-copy',
  templateUrl: './new-my-project-copy.component.html',
  styleUrls: ['./new-my-project-copy.component.scss'],
})
export class NewMyProjectCopyComponent {
  modalLabel: any;
  myProjectData: any;
  myProjectForm!: FormGroup;
  submitted!: boolean;
  shareItems: any;
  projectStatusList: any;
  selectCountry: any;
  selectOrganization: any;
  defaultRegionItems: any;
  materialItems: any;
  isHideDropDown = false;
  isShowTeamList = false;
  teamList: any;
  organizationlist: any;
  selectTeamItems: any;
  selectSharedItem: any;
  selectCountryItems: any;
  headerBtn = 'Add row';
  headerBtnName = 'myNewAddProject';
  @Output() saveNewCopyMyProjectEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public projectFacade: ProjectsFacade
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.myProjectData = this.modal?.modalService?.config?.initialState?.['newMyProjects'];
    this.isHideDropDown =
      this.modal?.modalService?.config?.initialState?.['pathName'] == 'admin-projects'
        ? true
        : false;
    this.shareItems = this.myProjectData.shareItems;
    this.projectStatusList = this.myProjectData.projectStatusList;
    this.defaultRegionItems = this.myProjectData.regionItems;
    this.teamList = this.myProjectData.projectTeamList;
    this.isShowTeamList = this.myProjectData.teamId ? true : false;
    this.organizationlist = this.myProjectData.organizationItems;
    this.organizatioListFunction();
    this.sharedFunction();
    this.defaultCountryFunction();
    this.selectTeamFunction();
  }

  ngOnInit() {
    this.myProjectForm = this.formBuilder.group({
      projectName: [
        this.myProjectData.projectName || '',
        [Validators.required, Validators.maxLength(100)],
      ],
      projectNameForReport: [
        this.myProjectData.shortProjectName || '',
        [Validators.required, Validators.maxLength(300)],
      ],
      share: [null, Validators.required],
      team: [null],
      status: [this.myProjectData.statusId || null, Validators.required],
      organizationName: [null],
      defaultCountry: [null, Validators.required],
      description: [this.myProjectData.description || ''],
      boundryJustification: [this.myProjectData.interpretation || ''],
    });
    this.setFormData();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.myProjectData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async sharedFunction() {
    await this.shareItems.map((item: any) => {
      if (item.id == this.myProjectData.shareId) {
        return (this.selectSharedItem = item);
      }
    });
  }

  async selectTeamFunction() {
    await this.teamList.map((item: any) => {
      if (item.id == this.myProjectData.teamId) {
        return (this.selectTeamItems = item);
      }
    });
  }

  async defaultCountryFunction() {
    await this.defaultRegionItems.map((item: any) => {
      if (item.id == this.myProjectData.countryId) {
        return (this.selectCountryItems = item);
      }
    });
  }

  setFormData() {
    this.myProjectForm.patchValue({
      organizationName: this.selectOrganization,
      share: this.selectSharedItem,
      defaultCountry: this.selectCountryItems,
      team: this.selectTeamItems,
    });
  }

  onClose() {
    this.modal.close();
    this.projectFacade.clearDefaultMaterial();
  }

  selectTeam(data: any) {
    this.isShowTeamList = data.name == 'One of my team' ? true : false;
  }

  getProjectname(value: any) {
    this.myProjectForm.controls['projectNameForReport'].setValue(value);
  }

  onSave() {
    this.submitted = true;
    if (
      !this.myProjectForm.valid ||
      (this.isShowTeamList && !this.myProjectForm.controls['team'].value)
    ) {
      return;
    }
    const projecPayload = {
      projectId: this.myProjectData.projectId,
      projectName: this.myProjectForm.controls['projectName'].value,
      shortProjectName: this.myProjectForm.controls['projectNameForReport'].value,
      shareId: this.myProjectForm.controls['share'].value.id,
      statusId: this.myProjectForm.controls['status'].value || this.myProjectData.statusId,
      organizationId:
        this.myProjectForm.controls['organizationName'].value?.id ||
        this.myProjectData.organizationId,
      countryId: this.myProjectForm.controls['defaultCountry'].value.id,
      teamId: this.myProjectForm.controls['team'].value?.id,
      Description: addFullStop(this.myProjectForm.controls['description'].value),
      Interpretation: addFullStop(this.myProjectForm.controls['boundryJustification'].value),
    };
    this.saveNewCopyMyProjectEvent.emit(projecPayload);
  }
}
